import { BreakPoints } from '@picsart/cascade';
import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    content: {
      padding: [60],
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      [mediaQuery(BreakPoints.Small)]: {
        padding: [24],
      },
    },
    box: {
      flex: 1,
      flexDirection: 'column',
      maxWidth: 566,
      [mediaQuery(BreakPoints.Small)]: {
        maxWidth: '100%',
      },
    },
    heading: {
      fontSize: 30,
      lineHeight: '36px',
      fontWeight: 700,
      marginBottom: 24,
      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 24,
        lineHeight: '30px',
      },
    },
    alert: {
      position: 'absolute',
      top: 76,
      zIndex: 100,
      maxWidth: '664px',
      width: '100%',
      [mediaQuery(breakpoints.tablet)]: {
        top: 115,
      },
    },
    label: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 700,
      color: 'var(--x-black-1)',
      marginBottom: 16,
      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '24px',
        lineHeight: '32px',
        padding: [0, 24],
      },
    },

    results: {
      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, 24],
      },
    },
  }),
  {
    name: 'main-content',
  },
);

export default useStyles;
